import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import Home from "@/pages/Home";
import HouseOfRudra from "@/pages/HouseOfRudra";
import CoalMiningPage from "@/pages/CoalMiningPage";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Disclaimer from "@/pages/Disclaimer";
import { AuthProvider } from "@/portal/AuthContext";
import ProtectedRoute from "@/portal/ProtectedRoute";
import PortalLayout from "@/portal/PortalLayout";
import Login from "@/portal/pages/Login";
import Dashboard from "@/portal/pages/Dashboard";
import Team from "@/portal/pages/Team";
import ProjectDetail from "@/portal/pages/ProjectDetail";

function App() {
  return (
    <div className="App font-body">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/house-of-rudra" element={<HouseOfRudra />} />
            <Route path="/coal-mining" element={<CoalMiningPage />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
            <Route path="/portal" element={<Login />} />
            <Route
              element={
                <ProtectedRoute>
                  <PortalLayout />
                </ProtectedRoute>
              }
            >
              <Route path="/portal/dashboard" element={<Dashboard />} />
              <Route path="/portal/projects/:id" element={<ProjectDetail />} />
              <Route
                path="/portal/team"
                element={
                  <ProtectedRoute adminOnly>
                    <Team />
                  </ProtectedRoute>
                }
              />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <Toaster
        position="bottom-center"
        theme="dark"
        toastOptions={{
          style: {
            background: "#121215",
            border: "1px solid rgba(212, 175, 55, 0.35)",
            color: "#FAFAFA",
            fontFamily: "'Outfit', sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
